export default function searchInit() {
  document.addEventListener("DOMContentLoaded", function () {
    console.debug("Init Search");

    document
      .getElementById("search-toggle")
      ?.addEventListener("click", toggleSearchModal);

    document
      .getElementById("search-modal")
      ?.addEventListener("click", (event) => {
        if (event.target === event.currentTarget) {
          toggleSearchModal(event);
        }
      });
    document
      .getElementById("dummy-search")
      ?.addEventListener("focus", (event) => {
        toggleSearchModal(event);
      });
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      toggleSearchModal(event, false);
    }
  });
}

function toggleSearchModal(
  event: Event,
  open: boolean | undefined = undefined,
) {
  event.preventDefault();
  const modal = document.getElementById("search-modal");
  if (!modal) return;
  const dummy = document.getElementById("dummy-search");
  if (open === undefined) {
    open = !modal.classList.contains("show");
  }
  if (open) {
    modal.classList.add("show");
    document.getElementById("search-input")?.focus();
    if (dummy) dummy.classList.add("hide");
  } else {
    modal.classList.remove("show");
    if (dummy) dummy.classList.remove("hide");
  }
}
